module.exports = __webpack_public_path__ + "joy-static/media/Map.858a0052.png";